<template>
  <v-card class="ma-5 mx-auto" :flat="this.$vuetify.breakpoint.mobile" >
    <v-card-title>Online Users</v-card-title>
    <v-simple-table dense>
      <template v-slot:default>
        <thead>
        <tr>
          <th class="text-left">Username</th>
          <th class="text-left">Boat Name</th>
          <th class="text-left">Mode</th>
          <th class="text-left">Status</th>
          <th class="text-left"></th>
          <th v-if="showUserDetails" class="text-left" style="background-color: lightgray">Registered</th>
          <th v-if="showUserDetails" class="text-left" style="background-color: lightgray">Version</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="motionInfo in motionInfos" :key="motionInfo.id">
          <td>{{ motionInfo.user.username }}</td>
          <td>{{ motionInfo.boatName }}</td>
          <td>{{ motionInfo.multiplayerMode }}</td>
          <td>{{ getStatusText(motionInfo) }}</td>
          <td>
            <div style="margin: -5px;">
              <country-flag v-if="motionInfo.user.country" :country='motionInfo.user.country'/>
            </div>
          </td>
          <td v-if="showUserDetails" style="background-color: lightgray">{{ motionInfo.user.registrationDate | formatDate }}</td>
          <td v-if="showUserDetails" style="background-color: lightgray">{{ motionInfo.user.esailVersion }}</td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-card-actions v-if="motionInfos != null && motionInfos.length > 0">
      <v-btn text color="teal accent-4" v-if="!show" @click="show = !show">Show More</v-btn>
      <v-btn text color="teal accent-4" v-if="show" @click="show = !show">Show Less</v-btn>
      <v-spacer></v-spacer>
      <v-btn icon @click="show = !show">
        <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
      </v-btn>
    </v-card-actions>
    <v-expand-transition>
      <div v-if="show">
        <v-divider></v-divider>
        <v-container fluid>
          <v-row>
              <GMap :motionInfos="motionInfos" :showRefreshBtn="true"
                    v-on:refresh-required="updateGMapAvatars" v-on:auto-refresh-required="autoUpdateGMapAvatars" v-on:auto-refresh-cancelled="cancelAutoUpdateGMapAvatars" style="width:100%; padding-top: 100%;"></GMap>
          </v-row>
        </v-container>
      </div>
    </v-expand-transition>
  </v-card>
</template>

<script>

import _ from 'lodash';
import AuthMixin from "@/mixins/AuthMixin";
import {eSailServerPublic} from "@/plugins/axios";
import GMap from './GMap';

export default {
  name: "OnlineUsersCard",
  components: {
    GMap
  },
  mixins: [
    AuthMixin
  ],
  data: () => ({
    show: false,
    motionInfos: null,
    autoUpdateTimer: null
  }),
  computed: {
    showUserDetails() {
      return this.isAuthorized('ADMIN')
    }
  },
  mounted() {
    this.updateGMapAvatars()
  },
  beforeDestroy() {
    clearInterval(this.autoUpdateTimer)
  },
  methods: {
    updateGMapAvatars() {
      if (!this.show && this.autoUpdateTimer) {
        this.cancelAutoUpdateGMapAvatars()
        return
      }
      eSailServerPublic.get('info/game/users/position')
        .then(response => {
          this.motionInfos = response.data
          _.each(this.motionInfos, item => {
            item.multiplayerMode = item.multiplayerMode === "UTC" ? "Multiplayer" : "Multiplayer +12h"
          })
        })
    },
    autoUpdateGMapAvatars() {
      this.autoUpdateTimer = setInterval(this.updateGMapAvatars, 30000);
    },
    cancelAutoUpdateGMapAvatars() {
      if (this.autoUpdateTimer) {
        clearInterval(this.autoUpdateTimer)
        this.autoUpdateTimer = null
      }
    },
    getStatusText(motionInfo) {
      if (motionInfo.pausing === true) {
        return "paused";
      } else if (motionInfo.user.currentChallengeName) {
        return "challenge"
      } else if (motionInfo.anchoring === true) {
        return "anchored";
      } else if (motionInfo.mooring === true) {
        return "moored";
      } else if (motionInfo.engineOn === true) {
        return "motoring";
      } else {
        return "sailing"
      }
    }
  }
}
</script>

<style scoped>

</style>